import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EvaluationClientRoutingModule } from './evaluation-client-routing.module';
import { EvaluationReceivedComponent } from './evaluation-received/evaluation-received.component';
import { EvaluationSentComponent } from './evaluation-sent/evaluation-sent.component';
import { TemplateEvaluationClientComponent } from './template-evaluation-client/template-evaluation-client.component';
import { QuestionQuizComponent } from './question-quiz/question-quiz.component';
import { TemplateEvalComponent } from './template-eval/template-eval.component';


@NgModule({
  declarations: [
    EvaluationReceivedComponent,
    EvaluationSentComponent,
    TemplateEvaluationClientComponent,
    QuestionQuizComponent,
    TemplateEvalComponent
  ],
  imports: [
    CommonModule,
    EvaluationClientRoutingModule
  ]
})
export class EvaluationClientModule { }
